var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMobile = function SvgMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 2.5h-9v19h9v-19ZM7.5 1A1.5 1.5 0 0 0 6 2.5v19A1.5 1.5 0 0 0 7.5 23h9a1.5 1.5 0 0 0 1.5-1.5v-19A1.5 1.5 0 0 0 16.5 1h-9Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 20.75h-4v-1.5h4v1.5Z",
    fill: "currentColor"
  })));
};
export { SvgMobile as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNi41IDIuNUg3LjVWMjEuNUgxNi41VjIuNVpNNy41IDFDNi42NzE1NyAxIDYgMS42NzE1NyA2IDIuNVYyMS41QzYgMjIuMzI4NCA2LjY3MTU3IDIzIDcuNSAyM0gxNi41QzE3LjMyODQgMjMgMTggMjIuMzI4NCAxOCAyMS41VjIuNUMxOCAxLjY3MTU3IDE3LjMyODQgMSAxNi41IDFINy41WiIgZmlsbD0iY3VycmVudENvbG9yIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTQgMjAuNzVIMTBWMTkuMjVIMTRWMjAuNzVaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";